import React from 'react';
import { Formik, Form, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import Button from '../AppButton/Button';
import FormInputText from './Inputs/FormInputText';
import { ParentPasswordSetFormType } from './form-types';
import { getCookie, transformErrors } from '../../services/utils';
import { GlobalTypes, useGlobalState } from '../../contexts/global';
import { setParentPassword } from '../../moduls/profile';

const initialValues = {
    new_parent_password: '',
    new_parent_password_confirmation: ''
};

const attributes = {
    new_parent_password: {
        placeholder: 'Vyplňte..',
        label: 'Rodičovské heslo',
        password: true
    },
    new_parent_password_confirmation: {
        placeholder: 'Vyplňte..',
        label: 'Rodičovské heslo znovu',
        password: true
    }
};

const SetParentPasswordForm: React.FC<{callback: (parentPassword: string, parentPasswordConfirmation: string) => void}> = ({ callback }) => {
    const { dispatch } = useGlobalState();
    const onSubmit = async (values: ParentPasswordSetFormType, { setErrors, resetForm }: FormikHelpers<ParentPasswordSetFormType>) => {
        let parentPassword = values.new_parent_password;
        let parentPasswordConfirmation = values.new_parent_password_confirmation;
        
        if (getCookie('jid')) {
            return setParentPassword(values)
                .then(() => {
                    resetForm();
                    dispatch({ type: GlobalTypes.ToggleModal, modal: '' });

                    callback(parentPassword, parentPasswordConfirmation);
                })
                .catch((error) => setErrors(transformErrors(error)));
        } else {            
            resetForm();
            dispatch({ type: GlobalTypes.ToggleModal, modal: '' });

            callback(parentPassword, parentPasswordConfirmation);
        }
    };

    const validationSchema = Yup.object().shape({
        // eslint-disable-next-line
        new_parent_password: Yup.string().min(8, 'Minimální délka je ${min} znaků').required('Povinné pole'),
        new_parent_password_confirmation: Yup.string()
            .oneOf([Yup.ref('new_parent_password'), undefined], 'Hesla se musí shodovat')
            .required('Povinné pole'),
    });

    return (
        <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
            {({ isValid, dirty, isSubmitting }) => (
                <Form>
                    <FormInputText name="new_parent_password" attributes={attributes.new_parent_password} />
                    <FormInputText name="new_parent_password_confirmation" attributes={attributes.new_parent_password_confirmation} />
                    <div className="h-text-center h-mt-1">
                        <Button type="submit" color="primary" disabled={!(isValid && dirty)} loading={isSubmitting}>
                            Odeslat
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default SetParentPasswordForm;
